import React, { useMemo, useState } from "react";
import "./Gdddm.css";

const TABS = [
  { key: "khan-vai", label: "KHĂN VẢI" },
  { key: "may-va", label: "PHỤ KIỆN MAY VÁ" },
  { key: "tham-dem", label: "THẢM, ĐỆM LÓT" },
  { key: "chan-goi", label: "CHĂN, GỐI" },
];

const ALL = [
  {
    id: 1,
    tab: "may-va",
    qty: 300,
    name: "Tạp dề nấu ăn cô gái",
    price: 12700,
    img: "/6ddm/1.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 2,
    tab: "khan-vai",
    qty: 100,
    name: "Set 10 Khăn Lau Đa Năng Vàng Xám 30x30cm",
    price: 32600,
    img: "/6ddm/2.jpeg",
    href: "#",
    cornerIcon: false,
    isNew: true,
  },
  {
    id: 3,
    tab: "chan-goi",
    qty: 20,
    name: "Gối ôm cao su non hàng VNXK 100x20cm",
    price: 168800,
    img: "/6ddm/3.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 4,
    tab: "chan-goi",
    qty: 25,
    name: "Gối cao su non hàng VNXK 60x30cm",
    price: 69800,
    img: "/6ddm/4.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 5,
    tab: "tham-dem",
    qty: 60,
    name: "Thảm/ga họa tiết (combo)",
    price: 45900,
    img: "/6ddm/5.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 6,
    tab: "chan-goi",
    qty: 15,
    name: "Gấu bông/đệm tựa (set)",
    price: 79900,
    img: "/6ddm/6.jpeg",
    href: "#",
    cornerIcon: true,
  },
  {
    id: 7,
    tab: "khan-vai",
    qty: 80,
    name: "Khăn lau siêu thấm (xám)",
    price: 19900,
    img: "/6ddm/7.jpeg",
    href: "#",
  },
  {
    id: 8,
    tab: "khan-vai",
    qty: 40,
    name: "Khăn MUJI (túi)",
    price: 32900,
    img: "/6ddm/8.jpeg",
    href: "#",
  },
];

function formatVND(n) {
  return new Intl.NumberFormat("vi-VN").format(n) + "đ";
}

export default function Gdddm() {
  const [tab, setTab] = useState(TABS[0].key);

  const products = useMemo(() => {
    const filtered = ALL.filter((p) => p.tab === tab);
    if (filtered.length >= 8) return filtered.slice(0, 8);
    const rest = ALL.filter((p) => p.tab !== tab);
    return [...filtered, ...rest].slice(0, 8);
  }, [tab]);

  return (
    <section className="tx">
      <div className="tx__container">
        <div className="tx__head">
          <h2 className="tx__title">ĐỒ DỆT MAY</h2>

          <div
            className="tx__tabs"
            role="tablist"
            aria-label="Danh mục đồ dệt may"
          >
            {TABS.map((t) => (
              <button
                key={t.key}
                type="button"
                className={`tx__tab ${tab === t.key ? "is-active" : ""}`}
                onClick={() => setTab(t.key)}
                role="tab"
                aria-selected={tab === t.key}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="tx__grid">
          {products.map((p) => (
            <a className="tx__card" href={p.href} key={p.id}>
              <div className="tx__media">
                <img
                  className="tx__img"
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                />
                {p.cornerIcon && (
                  <span className="tx__cornerIcon" aria-hidden="true" />
                )}
              </div>

              <div className="tx__meta">
                <div className="tx__name">
                  <span className="tx__qty">[{p.qty}]</span>{" "}
                  <span className="tx__nameText">
                    {p.name}{" "}
                    {p.isNew ? <span className="tx__new">(NEW)</span> : null}
                  </span>
                </div>
                <div className="tx__price">{formatVND(p.price)}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
